module.exports = __webpack_public_path__ + "static/img/helena.f7d72beb.jpg";